const caseStudies = [
  {
    id: 'engine-harness-assemblies',
    img: '/images/engine-harness-assemblies.jpg',
    alt: 'engine-harness-assemblies',
    tag: 'engine-harness-assemblies',
    title: 'engine-harness-assemblies',
    description: 'PTFE-insulated, EMI-shielded harnesses meeting strict weight and performance requirements.',
  },
  {
    id: 'automotive',
    img: 'https://harshadawh.com/assets/images/BigHarnesses/Artboard_11.jpg',
    alt: 'EV Automotive',
    tag: 'EV / Automotive',
    title: 'High-Voltage Battery Harnesses for Commercial EVs',
    description: 'Robust insulation systems and custom strain relief for high-power distribution.',
  },
  {
    id: 'robotics',
    img: 'https://harshadawh.com/assets/images/BigHarnesses/Artboard_13.jpg',
    alt: 'Industrial Robotics',
    tag: 'Robotics',
    title: 'Continuous-Flex Harnesses for Surgical Robots',
    description: 'Tested for millions of cycles with zero signal degradation.',
  },
   {
    id: 'robotics',
    img: 'https://harshadawh.com/assets/images/BigHarnesses/Artboard_12.jpg',
    alt: 'Industrial Robotics',
    tag: 'Robotics',
    title: 'Continuous-Flex Harnesses for Surgical Robots',
    description: 'Tested for millions of cycles with zero signal degradation.',
  },
    {
    id: 'washing-machine-harness1',
    img: '/images/washing-machine-harness1.jpg',
    alt: 'Industrial Robotics',
    tag: 'washing-machine-harness1',
    title: 'washing-machine-harness1',
    description: 'Tested for millions of cycles with zero signal degradation.',

  },
     {
    id: 'prototype-wiring-harness',
    img: '/images/washing-machine-harness1.jpg',
    alt: 'prototype-wiring-harness',
    tag: 'prototype-wiring-harness',
    title: 'prototype-wiring-harness',
    description: 'Tested for millions of cycles with zero signal degradation.',
  },
];

export default caseStudies;
